import {inject, Injectable} from '@angular/core';
import {AUTHENTICATION_SERVICE,
  AuthenticationService} from 'src/app/shared/services/authentication/authentication.service';
import {ENVIRONMENT} from 'src/environments/environment.token';

@Injectable({
  providedIn: 'root',
})
export class AirtelRedirectService {
  private readonly environment = inject(ENVIRONMENT);
  private authenticationService = inject<AuthenticationService>(AUTHENTICATION_SERVICE);
  showError(): boolean {
    const externalLogin = sessionStorage.getItem('x-pp-external-login');

    return this.environment.appConfig.authMePath.includes('airtel') &&
    (externalLogin !== null) || this.authenticationService.userInfo?.userId === null;
  }
}
